import { useState } from 'react';
import '../components/suggestionbox.css';
import supabase from '../config/supabaseClient';

export default function SuggestionBox() {
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data: { user } } = await supabase.auth.getUser();

      const { error } = await supabase
        .from('suggestions')
        .insert([
          {
            feedback: feedback,
            user_id: user ? user.id : null
          }
        ]);

      if (error) throw error;

      alert('✅ Thank you for your feedback!');
      setFeedback('');
    } catch (err) {
      console.error('❌ Error submitting suggestion:', err.message);
      alert('There was a problem submitting your feedback.');
    }
  };

  return (
    <div className="suggestion-wrapper">
      <p className="suggestion-description">
        We’d love to hear your thoughts or suggestions to help improve Screen to Scene!
      </p>

      <form onSubmit={handleSubmit}>
        <textarea
          className="suggestion-textarea"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Please enter your feedback here"
          rows={6}
        />

        <button type="submit" className="suggestion-submit">
          Submit
        </button>
      </form>
    </div>
  );
}
